module.exports = __webpack_public_path__ + "img/taste-table4.d6f3c30d.png";